/**
 * Tracking type (used by KenobiService)
 */
export enum Type {
    CONTRACT = 'CONTRACT',
    ACCOUNT = 'ACCOUNT',
}
